import * as React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import {
  Box,
  Typography,
  MenuList,
  MenuItem,
  ListItemText,
  Divider,
  Drawer
} from '@mui/material';

import { CONST } from '../../utils';
import { Home, Orders, AreaReport, CandidDhr, CandidHistory} from './components';

const newItem = (name, comp) => {
    return {
        name: name,
        comp: () => comp
    };
}

const MenuItems = [
    newItem('Home', Home),
    newItem('Orders', Orders.Main),
    newItem('Area Report', AreaReport.Main),
    newItem('Candid DHRs', CandidDhr.Main),
    newItem('Candid History', CandidHistory.Main),
]

export default function Main() {

    document.title = 'PM - MAIN';

    const [Comp, setComp ] = React.useState(() => Home);
    const [Props, setProps] = React.useState({})

    const handleChange = async(comp, props) => {
        setComp(() => comp);
        setProps(props);
    }

    return(
        <Box
            sx={{
                display: 'flex',
                width: "100%", 
                height: "100%",
            }}
        >
            <Box
                sx={{
                    width: 130,
                    flexShrink: 0,
                    backgroundColor: CONST.Colors.Primary.Main
                }}
            >
                <Divider
                    sx={{
                        borderColor:CONST.Colors.Font.White
                    }}
                />
                <Typography variant='h5' paddingX={2} color={CONST.Colors.Font.White}>MENU</Typography>
                <Divider
                    sx={{
                        borderColor:CONST.Colors.Font.White
                    }}
                />

                <MenuList>
                        {MenuItems.map((item) => (
                            <MenuItem onClick={() => setComp(item.comp)}>
                                <ListItemText sx={{color: CONST.Colors.Font.White}}>{item.name}</ListItemText>
                            </MenuItem>
                        ))}
                </MenuList>
            </Box>

            <Box
                sx={{ flexGrow: 1, padding: 2, overflowY: "auto" }}
            >
                <Comp handleChange={handleChange} itemProps={Props}/>
            </Box>

        </Box>
    );
}